import { getDriveItemAttachmentLinks, getDriveItemShareableLinks } from "./GraphService";
import authModule from "../../../utilities/AuthModule";
import { IEmailAttachment } from "../interfaces/services/IEmailAttachment";
import { IDriveInfo } from "../interfaces/IDriveInfo";

export class AttachmentService {
  static async getAttachmentLinks(items: IDriveInfo[]): Promise<IEmailAttachment[]> {
    const results = await getDriveItemAttachmentLinks(await authModule.getGraphAccessToken(), items);
    return results.map(result => ({
      type: "file",
      name: result.name,
      url: result.webUrl,
      isInline: false
    }));
  }

  static async getShareableLinks(items: IDriveInfo[], isOrganization: boolean): Promise<IEmailAttachment[]> {
    return items.map(item => ({
      type: "file",
      name: item.name,
      url: item.webUrl,
      isInline: false,
      adminHasGivenSiteShareableRightsForUser: false
    }));
  }
}
